import {
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';
import * as bookingData from './bookingHistory.json';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastService } from 'src/app/core/services/toast.service';
import { DataTransferServiceService } from 'src/app/core/services/data-transfer-service.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss'],
})
export class BookingComponent implements OnDestroy {
  @Output() bookingData = new EventEmitter<any>();
  image: any;
  bookingHistory: any;
  url!: string;
  bookingHistoryNames: any = [];
  bookingHistoryDeadline: any = [];
  searchQuery: string = '';
  filteredBookings: any = [];
  filteredData: boolean = false;
  // isExpanded: boolean = false;
  expandedRowIndex: number | null = null;
  unpaidCount: any;
  remainingCredit: any;
  bookingRefId: any;
  isActive: boolean = false;
  isActiveRecent: boolean = false;
  isActiveTransfer: boolean = false;
  isActiveUnpaid: boolean = false;
  supplierRefId: any;
  supplier: any;
  bookingHistorySub!: Subscription;
  bookingCancelSub!: Subscription;
  noBookingAvailable: boolean = false;
  apiCurrencyValue: any;
  currencyCode: any;
  loader: boolean = false;
  isTransferRowExpanded: boolean = false;
  bookingTransfersHistory: any;
  // isActiveRecent = false;
  // isActiveUnpaid = false;
  // isActiveTransfer = false;

  backUpArray: any;
  refreshInterval: any;
  closingModalRef1!: BsModalRef;
  @ViewChild('inactiveModal', { static: true }) inactiveModal: any;
  closingTimeout: any;
  ratehawkApiCurrencyValue: any;
  @ViewChild('pdfModal', { static: true }) pdfModal: any;
  pdfSrc: any;
  paypalConvertedCurrency: any;
  paypalConvertedPrice: any;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private commonService: CommonService,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private toastService: ToastService,
    private dataTransferService: DataTransferServiceService
  ) {
    this.getCurrency();
  }

  closingModalRef!: BsModalRef;
  closingLoaderModalRef!: BsModalRef;
  @ViewChild('cancelModal', { static: true }) cancelModal: any;
  @ViewChild('loaderModal', { static: true }) loaderModal: any;

  ngOnInit() {
    // this.transfersHistory()
    this.toggleAccAndTransfer('accommodation');
    this.refreshInterval = setInterval(() => {
      this.closingModalRef1 = this.modalService?.show(this.inactiveModal, {
        class: 'modal-md modal-dialog-centered',
      });
      this.closingTimeout = setTimeout(() => {
        this.closingModalRef1?.hide;
        window.location.reload();
      }, 4000);
    }, 1800000);
    this.toggleActive('recent');
    this.filterRecent();
    this.url = this.router?.url?.slice(1);
    // this.bookingHistory = bookingData?.bookingHistory;
    this.image = this.configService?.getImages();
    // console.log(this.router.url)
  }

  openModal(refId: any, suppId: any, supplier: any) {
    this.bookingRefId = refId;
    this.supplier = supplier;
    this.supplierRefId = suppId;
    this.closingModalRef = this.modalService?.show(this.cancelModal, {
      class: 'modal-md modal-dialog-centered',
    });
  }

  getCurrency() {
    const storedCurrency = sessionStorage?.getItem('currency');
    if (storedCurrency) {
      let currencyData = JSON?.parse(storedCurrency);
      this.currencyCode = currencyData?.code;
    }
    this.commonService
      .updateCurrency('USD', this.currencyCode)
      .subscribe((data: any) => {
        console.log(data);
        this.apiCurrencyValue = data.rates[this.currencyCode];
        // sessionStorage.setItem('currencyApi', data.rates[this.currencyCode]);
      });
    this.commonService
      .updateCurrency('GBP', this.currencyCode)
      .subscribe((data: any) => {
        console.log(data);
        this.ratehawkApiCurrencyValue = data.rates[this.currencyCode];
        // sessionStorage.setItem('ratehawkCurrencyApi', data.rates[this.currencyCode]);
      });
    // this.apiCurrencyValue = sessionStorage.getItem('currencyApi');
    // this.ratehawkApiCurrencyValue = sessionStorage.getItem(
    //   'ratehawkCurrencyApi'
    // )
    // this.cd.detectChanges();
    // this.cd.markForCheck();
  }

  openLoaderModal() {
    this.closingLoaderModalRef = this.modalService?.show(this.loaderModal, {
      class: 'modal-md modal-dialog-centered',
    });
  }

  toggleActive(type: string): void {
    if (type === 'recent') {
      this.isActiveRecent = true;
      this.isActiveUnpaid = false;
    } else if (type === 'unpaid') {
      this.isActiveRecent = false;
      this.isActiveUnpaid = true;
    }
  }

  toggleAccAndTransfer(type: string) {
    if (type == 'accommodation') {
      this.bookingHistoryApi();
      this.isActiveTransfer = false;
    } else {
      this.transfersHistory();
      this.isActiveTransfer = true;
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabLabel = event.tab.textLabel;
    if (tabLabel === 'Accommodation') {
      this.toggleAccAndTransfer('accommodation');
    } else if (tabLabel === 'Transfers') {
      this.toggleAccAndTransfer('transfer');
    }
  }

  closeModal() {
    // setTimeout(() => {
    this.closingModalRef?.hide();
    // this.router.navigate(['/MyBookings']);
    // }, 2000);
  }
  loaderCloseModal() {
    // setTimeout(() => {
    this.closingLoaderModalRef?.hide();
    // this.router.navigate(['/MyBookings']);
    // }, 2000);
  }

  toggleRow(index: number): void {
    this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRowIndex === index;
  }

  navigate() {
    this.router?.navigate(['/MyBookings']);
  }

  payNow(refId: any, price: any, convertedCurrency: any) {
    this.commonService.updateCurrency(this.currencyCode, 'AED').subscribe((data: any) => {
      this.paypalConvertedCurrency = data.base;
      this.paypalConvertedPrice = data.rates.AED
      let url = window.location.href;
      let baseUrl = url.split('/').slice(0, 3).join('/') + '/';
      let params = {
        amount: Number((this.calculateTotalPrice(price) * this.paypalConvertedPrice).toFixed(2)),
        currency: 'AED',
        url: baseUrl + "accomodations",
        bookingRefId: refId
      };

        this.commonService.stripeBooking(params).subscribe((data) => {
          console.log(data);

          sessionStorage.setItem('bookingRefId', data.bookingRefId);

          window.location.href = data.url;
        });
      });
  }

  calculatePercentOfTotalPrice(price: any): number {
    let totalPrice = parseFloat(price);
    if (!isNaN(totalPrice)) {
      // Calculate the price with an additional 1.5% charge
      return +(totalPrice * 0.044).toFixed(2); // Limit decimals to two
    }
    return 0;
  }

  calculateTotalPrice(price: any): number {
    let totalPrice = parseFloat(price);
    if (!isNaN(totalPrice)) {
      // Calculate the price with an additional 1.5% charge
      return +(totalPrice * 1.044).toFixed(2); // Limit decimals to two
    }
    return 0; // Or whatever default value you want to return if the calculation fails
  }

  downloadPDF() {
    this.openPdfModal('assets/docs/BankDetail.pdf');
    const link = document.createElement('a');
    link.href = 'assets/docs/BankDetail.pdf';
    link.download = 'Rateloc-Bank-Details.pdf';
    link.click();
  }

  openPdfModal(pdfPath: any) {
    this.pdfSrc = pdfPath;
    this.closingModalRef = this.modalService?.show(this.pdfModal, {
      class: 'modal-md',
    });
  }

  bookingHistoryApi() {
    this.bookingHistorySub?.unsubscribe();
    this.bookingHistorySub = this.commonService
      ?.bookingHistory()
      ?.subscribe((data: any) => {
        this.bookingHistory = data?.bookings;
        this.backUpArray = data?.bookings;
        this.noBookingAvailable = true;
        this.noBookingAvailable = this.bookingHistory?.length === 0;
        this.filteredBookings = data?.bookings;
        this.remainingCredit = data?.remainingCreditLimit;
        const totalPrice = this.bookingHistory?.reduce(
          (total: number, booking: any) => {
            return total + booking?.price;
          },
          0
        );
        const totalPriceUnpaid = this.bookingHistory?.reduce(
          (total: number, booking: any) => {
            if (booking?.paymentStatus === 'Unpaid') {
              return total + booking?.price;
            }
            return total;
          },
          0
        );
        const totalOrdersCount = this.bookingHistory?.length;

        // Confirmed orders count
        const confirmedOrdersCount = this.bookingHistory?.filter(
          (booking: any) => booking?.bookingStatus === 'Confirmed'
        )?.length;

        // Unpaid orders count
        const unpaidOrdersCount = this.bookingHistory?.filter(
          (booking: any) => booking?.paymentStatus === 'Unpaid'
        )?.length;
        this.unpaidCount = unpaidOrdersCount;

        let obj = {
          remainingCredit: this.remainingCredit,
          totalPrice: totalPrice,
          totalPriceUnpaid: totalPriceUnpaid,
          totalOrdersCount: totalOrdersCount,
          confirmedOrdersCount: confirmedOrdersCount,
          unpaidOrdersCount: unpaidOrdersCount,
        };
        this.dataTransferService?.setBookingHistoryData(obj);
        let json = this.bookingHistory?.forEach((ele: any, i: number) => {
          const datePipe = new DatePipe('en-US');
          let dateString = ele?.checkInDate;
          let parts = dateString?.split('-');
          let dateObject = new Date(
            Number(parts[2]),
            Number(parts[1]) - 1,
            Number(parts[0])
          );
          this.bookingHistory[i].checkInDate = datePipe?.transform(
            dateObject,
            'yyyy-MM-dd'
          );
          dateString = ele?.checkOutDate;
          parts = dateString?.split('-');
          dateObject = new Date(
            Number(parts[2]),
            Number(parts[1]) - 1,
            Number(parts[0])
          );
          this.bookingHistory[i].checkOutDate = datePipe?.transform(
            dateObject,
            'yyyy-MM-dd'
          );
          const jsonNamesArray = JSON?.parse(ele?.names);
          if (ele?.remarks && ele?.remarks != 'null') {
            const remarksArray = JSON?.parse(ele?.remarks);
            this.bookingHistory[i]['remarks'] = remarksArray;
          }
          this.bookingHistory[i]['rooms'] = jsonNamesArray;
          this.bookingHistory[i]['isCart'] = ['444', '666'].includes(
            ele.supplierName
          )
            ? true
            : false;

          console.log(this.bookingHistory);

          const jsonDeadlineArray = ele?.deadline;
          this.bookingHistory[i]['parsedNames'] = jsonNamesArray;
        });
        this.filterRecent();
        this.bookingData?.emit();
      });
  }

  bookingCancel() {
    this.closeModal();
    let params = {
      bookingRefId: this.bookingRefId,
      supplierRefId: this.supplierRefId,
      supplier: this.supplier,
    };

    this.bookingCancelSub?.unsubscribe();
    if (this.isActiveTransfer) {
      this.bookingCancelSub = this.commonService
        ?.transfersBookingCancel(params)
        ?.subscribe((data: any) => {
          // console.log(data);
          if (!data?.status) {
            this.toastService?.showInfo(data?.message);
          } else {
            this.bookingHistoryApi();
            // this.loaderCloseModal();
            this.toastService?.showSuccess(data?.message);
          }
          this.loaderCloseModal();
          this.closeModal();
        });
    } else {
      this.bookingCancelSub = this.commonService
        ?.bookingCancel(params)
        ?.subscribe((data: any) => {
          // console.log(data);
          if (!data?.status) {
            this.toastService?.showInfo(data?.message);
          } else {
            this.bookingHistoryApi();
            // this.loaderCloseModal();
            this.toastService?.showSuccess(data?.message);
          }
          this.loaderCloseModal();
          this.closeModal();
        });
    }
  }

  search() {
    this.filteredData = false;
    let newArr = [...this.bookingHistory];
    if (this.searchQuery == '') {
      this.bookingHistory = this.backUpArray;
      this.isActiveRecent ? this.filterRecent() : this.filterUnpaid();
    } else {
      this.bookingHistory = newArr?.filter((booking: any, i: number) => {
        const jsonNamesArray = JSON?.parse(booking?.names);
        const jsonDeadlineArray = booking?.deadline;
        this.bookingHistory[i]['parsedNames'] = jsonNamesArray;
        return booking?.bookingRefId
          ?.toLowerCase()
          ?.includes(this.searchQuery?.toLowerCase());
      });
    }
  }

  filterUnpaid() {
    this.isActive = !this.isActive;

    this.filteredData = true;
    this.filteredBookings = this.bookingHistory?.filter(
      (booking: any) => booking?.paymentStatus?.toLowerCase() == 'unpaid'
    );
  }

  filterRecent(): void {
    // Sort the bookings by bookedOn date in descending order
    this.isActive = false;
    this.bookingHistory = this.bookingHistory?.sort((a: any, b: any) => {
      const dateA = new Date(a?.bookedOn);
      const dateB = new Date(b?.bookedOn);
      return dateB?.getTime() - dateA?.getTime();
    });

    this.filteredData = false;
  }

  filterTransfers(): void {
    this.isActiveTransfer = true;
    // this.filteredBookings = this.bookingHistory?.filter(
    //     (booking: any) => booking?.type?.toLowerCase() === 'transfer'
    // );
    this.filteredData = true;
  }

  transfersHistory() {
    // this.bookingHistorySub?.unsubscribe()
    this.commonService?.transfersBookingHistory()?.subscribe((data: any) => {
      this.bookingTransfersHistory = data?.data.bookings;
      this.noBookingAvailable = true;
      this.noBookingAvailable = this.bookingHistory?.length === 0;
      // this.filteredBookings = data.data?.bookings;
      this.remainingCredit = data?.remainingCreditLimit;
      // const totalPrice = this.bookingHistory?.reduce(
      //   (total: number, booking: any) => {
      //     return total + booking?.price;
      //   },
      //   0
      // );
      // const totalPriceUnpaid = this.bookingHistory?.reduce(
      //   (total: number, booking: any) => {
      //     if (booking?.paymentStatus === 'Unpaid') {
      //       return total + booking?.price;
      //     }
      //     return total;
      //   },
      //   0
      // );
      // const totalOrdersCount = this.bookingHistory?.length;

      // Confirmed orders count
      // const confirmedOrdersCount = this.bookingHistory?.filter(
      //   (booking: any) => booking?.bookingStatus === 'Confirmed'
      // )?.length;

      // Unpaid orders count
      // const unpaidOrdersCount = this.bookingHistory?.filter(
      //   (booking: any) => booking?.paymentStatus === 'Unpaid'
      // )?.length;
      // this.unpaidCount = unpaidOrdersCount;

      // let obj = {
      //   remainingCredit: this.remainingCredit,
      //   totalPrice: totalPrice,
      //   totalPriceUnpaid: totalPriceUnpaid,
      //   totalOrdersCount: totalOrdersCount,
      //   confirmedOrdersCount: confirmedOrdersCount,
      //   unpaidOrdersCount: unpaidOrdersCount,
      // };
      // this.dataTransferService?.setBookingHistoryData(obj);
      // let json = this.bookingHistory?.forEach((ele: any, i: number) => {
      //   const datePipe = new DatePipe('en-US');
      //   let dateString = ele?.checkInDate;
      //   let parts = dateString?.split('-');
      //   let dateObject = new Date(
      //     Number(parts[2]),
      //     Number(parts[1]) - 1,
      //     Number(parts[0])
      //   );
      //   this.bookingHistory[i].checkInDate = datePipe?.transform(
      //     dateObject,
      //     'yyyy-MM-dd'
      //   );
      //   dateString = ele?.checkOutDate;
      //   parts = dateString?.split('-');
      //   dateObject = new Date(
      //     Number(parts[2]),
      //     Number(parts[1]) - 1,
      //     Number(parts[0])
      //   );
      //   this.bookingHistory[i].checkOutDate = datePipe?.transform(
      //     dateObject,
      //     'yyyy-MM-dd'
      //   );

      // });
      // this.bookingData?.emit();
    });
  }

  ngOnDestroy(): void {
    this.bookingHistorySub?.unsubscribe();
    this.bookingCancelSub?.unsubscribe();
    clearInterval(this.refreshInterval);
    clearTimeout(this.closingTimeout);
  }

  toggleTransferRow() {
    this.isTransferRowExpanded = !this.isTransferRowExpanded;
  }
}
